export const Materials = [
  {b:"Алевролит", c: 1700, d: 2600, e: 2000, f: 40, g: false},
  {b:"Амфиболит", c: 1200, d: 3150, e: 1420, f: 40, g: false},
  {b:"Ангидрит", c: 600, d: 3000, e: 1500, f: 40, g: true},
  {b:"Андезит", c: 820, d: 2700, e: 1400, f: 40, g: false},
  {b:"Аргиллит", c: 1000, d: 2600, e: 1300, f: 35, g: true},
  {b:"Асбест", c: 800, d: 2600, e: 300, f: 35, g: true},
  {b:"Асфальт", c: 920, d: 2700, e: 1600, f: 35, g: false},
  {b:"Базальт", c: 840, d: 3100, e: 1600, f: 40, g: false},
  {b:"Бакелит", c: 1590, d: 1280, e: 800, f: 30, g: false},
  {b:"Бетон", c: 1000, d: 2400, e: 1850, f: 40, g: true},
  {b:"Габбро-Диабаз", c: 1100, d: 3100, e: 1580, f: 40, g: false},
  {b:"Гипс", c: 1100, d: 2300, e: 1600, f: 35, g: true},
  {b:"Глина", c: 880, d: 1800, e: 1600, f: 30, g: false},
  {b:"Гранит", c: 750, d: 2600, e: 1650, f: 40, g: false},
  {b:"Графит", c: 840, d: 2230, e: 650, f: 30, g: false},
  {b:"Диатомит", c: 840, d: 700, e: 500, f: 35, g: false},
  {b:"Диорит", c: 1200, d: 2900, e: 1350, f: 40, g: false},
  {b:"Доломит", c: 1500, d: 2840, e: 1520, f: 40, g: false},
  {b:"Дуб", c: 2400, d: 720, e: 250, f: 40, g: false},
  {b:"Дунит", c: 800, d: 3280, e: 1700, f: 40, g: false},
  {b:"Железная руда", c: 500, d: 5300, e: 2500, f: 45, g: false},
  {b:"Зола", c: 800, d: 2500, e: 890, f: 35, g: false},
  {b:"Известняк", c: 920, d: 2700, e: 1550, f: 40, g: false},
  {b:"Известь", c: 840, d: 3300, e: 1200, f: 35, g: true},
  {b:"Ил", c: 2500, d: 1600, e: 1200, f: 20, g: false},
  {b:"Кальцит", c: 800, d: 2710, e: 1600, f: 40, g: false},
  {b:"Каолин", c: 880, d: 2650, e: 1100, f: 35, g: true},
  {b:"Кварц", c: 750, d: 2650, e: 1550, f: 40, g: false},
  {b:"Кварцит", c: 1300, d: 2680, e: 1800, f: 40, g: false},
  {b:"Кирпич", c: 840, d: 1800, e: 1200, f: 40, g: false},
  {b:"Кожа", c: 1510, d: 1900, e: 650, f: 35, g: false},
  {b:"Кокс ", c: 840, d: 1000, e: 500, f: 40, g: false},
  {b:"Колчедан медный", c: 980, d: 5000, e: 2200, f: 40, g: false},
  {b:"Колчедан серный", c: 1300, d: 5000, e: 2400, f: 40, g: false},
  {b:"Конгломерат", c: 850, d: 2650, e: 1700, f: 40, g: false},
  {b:"Мел", c: 880, d: 2720, e: 1440, f: 35, g: false},
  {b:"Мергель", c: 810, d: 2500, e: 1600, f: 35, g: false},
  {b:"Мрамор", c: 900, d: 2600, e: 1570, f: 40, g: false},
  {b:"Обсидиан", c: 1200, d: 2600, e: 1700, f: 40, g: false},
  {b:"Парафин", c: 2190, d: 1200, e: 900, f: 30, g: false},
  {b:"Песок", c: 835, d: 1700, e: 1400, f: 35, g: false},
  {b:"Песчаник", c: 960, d: 2670, e: 1450, f: 40, g: false},
  {b:"Пироксинит", c: 1200, d: 3350, e: 1900, f: 40, g: false},
  {b:"Пихта", c: 2700, d: 450, e: 220, f: 40, g: false},
  {b:"Полистирол", c: 1380, d: 1060, e: 600, f: 30, g: false},
  {b:"Полиуретан", c: 1380, d: 1260, e: 800, f: 30, g: false},
  {b:"Полихлорвинил", c: 1000, d: 1430, e: 900, f: 30, g: false},
  {b:"Порфирит", c: 1600, d: 1450, e: 900, f: 40, g: false},
  {b:"Пробка", c: 1380, d: 200, e: 100, f: 35, g: false},
  {b:"Резина твердая", c: 1420, d: 1300, e: 900, f: 35, g: false},
  {b:"Роговик", c: 1500, d: 2800, e: 1900, f: 40, g: false},
  {b:"Сера", c: 710, d: 2070, e: 1310, f: 35, g: false},
  {b:"Серпинтинит", c: 1100, d: 2700, e: 1800, f: 40, g: true},
  {b:"Сланец", c: 1600, d: 3000, e: 1800, f: 40, g: true},
  {b:"Слюда", c: 840, d: 2770, e: 1600, f: 28, g: true},
  {b:"Соль каменная", c: 920, d: 2165, e: 1150, f: 40, g: false},
  {b:"Соль поваренная", c: 880, d: 2165, e: 1150, f: 40, g: false},
  {b:"Стекловолокно", c: 840, d: 2500, e: 800, f: 30, g: false},
  {b:"Туф", c: 1400, d: 2500, e: 2180, f: 35, g: true},
  {b:"Уголь", c: 1500, d: 1400, e: 850, f: 38, g: false},
  {b:"Фарфор", c: 800, d: 2300, e: 1600, f: 40, g: false},
  {b:"Целлюлоза", c: 1550, d: 920, e: 400, f: 35, g: false},
  {b:"Цемент", c: 800, d: 2160, e: 1510, f: 35, g: false},
  {b:"Чернозем", c: 840, d: 1200, e: 900, f: 35, g: false},
  {b:"Чугун", c: 550, d: 7870, e: 5000, f: 35, g: false},
  {b:"Шифер", c: 750, d: 2000, e: 1200, f: 40, g: false},
]
